export default __webpack_public_path__ + "static/media/[icons].15621af3.svg";